import commonEn from "@locales/en/common.json";
import loyaltyEn from "@locales/en/loyalty.json";
import commonFr from "@locales/fr/common.json";
import loyaltyFr from "@locales/fr/loyalty.json";
import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

export const DEFAULT_LNG = "en";
export const DEFAULT_NS = "common";
export const RESOURCES = {
	fr: { common: commonFr, loyalty: loyaltyFr },
	en: { common: commonEn, loyalty: loyaltyEn },
} as const;

const ns = Object.keys(RESOURCES[DEFAULT_LNG]);

i18next
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: RESOURCES,
		ns,
		fallbackLng: DEFAULT_LNG,
		defaultNS: DEFAULT_NS,
		interpolation: {
			escapeValue: false,
		},
	});

export default i18next;
